import type { CSSProperties, FC } from 'react';

const styles: Record<string, CSSProperties> = {
  root: {
    marginTop: 112,
    textAlign: 'center',
    fontSize: 32,
    fontWeight: 400
  }
};

const HomePage: FC = () => <div style={styles.root}>Forte</div>;

export default HomePage;
